// Comprehensive Spice Catalogue Data for SPANXPORT
// Based on Indian Spices Board catalogue with enhanced descriptions

export const spicesData = [
  {
    id: "black-pepper",
    name: "Black Pepper",
    botanicalName: "Piper nigrum",
    family: "Piperaceae",
    commercialPart: "Fruit (dried berry)",
    image: "pepper",
    description: "Black pepper, known as the 'King of Spices', is the dried mature fruit of a perennial climbing vine. The plant is a woody climber that can grow up to 10 meters in height. The fruits are small, spherical drupes that turn from green to red when ripe. When dried, the outer layer becomes wrinkled and dark.",
    origin: "Black pepper is native to the Malabar Coast of India, particularly Kerala. India remains one of the largest producers and exporters. It is also cultivated in Vietnam, Indonesia, Brazil, and Sri Lanka. The spice thrives in tropical climates with high humidity and temperatures between 20-30°C.",
    uses: "Black pepper is used extensively in culinary applications worldwide. It adds heat and pungency to dishes and is a staple in spice blends. The essential oil is used in aromatherapy and perfumery. Medicinally, it aids digestion, has antioxidant properties, and enhances nutrient absorption. It is available as whole peppercorns, cracked, or ground.",
    indianNames: {
      Hindi: "Kali Mirch",
      Bengali: "Golmorich",
      Gujarati: "Kala Mari",
      Kannada: "Kari Menasu",
      Malayalam: "Kurumulaku",
      Marathi: "Kali Miri",
      Tamil: "Milagu",
      Telugu: "Miriyalu"
    },
    foreignNames: {
      Arabic: "Filfil Aswad",
      French: "Poivre Noir",
      German: "Schwarzer Pfeffer",
      Spanish: "Pimienta Negra",
      Chinese: "Hei Hu Jiao"
    },
    category: "major"
  },
  {
    id: "cardamom-small",
    name: "Cardamom (Small)",
    botanicalName: "Elettaria cardamomum",
    family: "Zingiberaceae",
    commercialPart: "Fruit (capsule with seeds)",
    image: "cardamom",
    description: "Small cardamom, the 'Queen of Spices', is a perennial herbaceous plant with thick, fleshy rhizomes. The plant grows 2-4 meters tall with long, dark green leaves. The fruit is a small, three-sided capsule containing aromatic black seeds. It has a sweet, pungent flavor with notes of eucalyptus and citrus.",
    origin: "Native to the evergreen forests of the Western Ghats in South India, particularly Kerala and Karnataka. Guatemala has become the world's largest producer. It grows best in tropical regions at elevations of 600-1500 meters with annual rainfall of 1500-4000mm.",
    uses: "Cardamom is used in both sweet and savory dishes. In India, it flavors chai, biryani, and desserts. Middle Eastern cuisine uses it in coffee and sweets. It's essential in garam masala. Medicinally, it aids digestion, freshens breath, and has antimicrobial properties. The essential oil is used in perfumery.",
    indianNames: {
      Hindi: "Chhoti Elaichi",
      Bengali: "Chhoto Elach",
      Gujarati: "Elchi",
      Kannada: "Yelakki",
      Malayalam: "Elakka",
      Marathi: "Velchi",
      Tamil: "Elakkai",
      Telugu: "Yelakulu"
    },
    foreignNames: {
      Arabic: "Haal",
      French: "Cardamome",
      German: "Kardamom",
      Persian: "Hel",
      Turkish: "Kakule"
    },
    category: "major"
  },
  {
    id: "turmeric",
    name: "Turmeric",
    botanicalName: "Curcuma longa",
    family: "Zingiberaceae",
    commercialPart: "Rhizome",
    image: "turmeric",
    description: "Turmeric is a perennial herbaceous plant with a short stem and large, oblong leaves. The rhizome is the commercially important part, characterized by its bright orange-yellow color due to curcumin content. The plant grows to about 1 meter in height and produces yellow-white flower spikes.",
    origin: "Native to South Asia, particularly India which produces nearly 80% of world supply. Major growing regions include Andhra Pradesh, Tamil Nadu, Odisha, and Maharashtra. It requires a warm, humid climate with temperatures of 20-30°C and well-distributed rainfall of 1500mm or more.",
    uses: "Turmeric is fundamental to Indian cooking, providing color and earthy flavor to curries. It's used in mustard, pickles, and cheese coloring. Curcumin has powerful anti-inflammatory and antioxidant properties, making it valuable in traditional medicine. It's used in cosmetics, textiles, and religious ceremonies.",
    indianNames: {
      Hindi: "Haldi",
      Bengali: "Holud",
      Gujarati: "Haldar",
      Kannada: "Arishina",
      Malayalam: "Manjal",
      Marathi: "Halad",
      Tamil: "Manjal",
      Telugu: "Pasupu"
    },
    foreignNames: {
      Arabic: "Kurkum",
      French: "Curcuma",
      German: "Gelbwurz",
      Japanese: "Ukon",
      Spanish: "Cúrcuma"
    },
    category: "major"
  },
  {
    id: "cumin",
    name: "Cumin",
    botanicalName: "Cuminum cyminum",
    family: "Apiaceae",
    commercialPart: "Fruit (seed)",
    image: "cumin",
    description: "Cumin is a small, delicate annual herb growing 30-50 cm tall. The plant has finely divided, thread-like leaves and small white or pink flowers in compound umbels. The fruit is an elongated, ridged seed with a distinctive warm, earthy aroma and slightly bitter, nutty taste.",
    origin: "Native to the eastern Mediterranean and South Asia. India is the world's largest producer and consumer, with Gujarat and Rajasthan being major producing states. It grows well in semi-arid tropical to subtropical climates with moderate temperatures and low humidity.",
    uses: "Cumin is essential in Indian, Middle Eastern, and Mexican cuisines. It's a key ingredient in curry powder, garam masala, and chili powder. The seeds are used whole or ground, and are often dry-roasted to enhance flavor. Medicinally, it aids digestion, has antimicrobial properties, and is rich in iron.",
    indianNames: {
      Hindi: "Jeera",
      Bengali: "Jeera",
      Gujarati: "Jiru",
      Kannada: "Jeerige",
      Malayalam: "Jeerakam",
      Marathi: "Jire",
      Tamil: "Seeragam",
      Telugu: "Jeelakarra"
    },
    foreignNames: {
      Arabic: "Kammun",
      French: "Cumin",
      German: "Kreuzkümmel",
      Persian: "Zireh",
      Spanish: "Comino"
    },
    category: "major"
  },
  {
    id: "chilli",
    name: "Chilli",
    botanicalName: "Capsicum annuum",
    family: "Solanaceae",
    commercialPart: "Fruit",
    image: "chilli",
    description: "Chilli is an annual or short-lived perennial plant with branching stems reaching 0.5-1.5 meters. The fruits vary greatly in size, shape, color, and pungency. The heat comes from capsaicin concentrated in the placenta and seeds. Varieties range from mild bell peppers to extremely hot Bhut Jolokia.",
    origin: "Native to Central and South America, introduced to Asia by Portuguese traders. India is now the world's largest producer, consumer, and exporter. Major growing regions include Andhra Pradesh, Karnataka, Maharashtra, and Madhya Pradesh. It requires warm temperatures above 20°C.",
    uses: "Chillies are used fresh, dried, or powdered in cuisines worldwide. They provide heat, color (especially paprika types), and flavor. Capsaicin has pain-relieving properties and is used in topical medications. Oleoresin is extracted for food coloring and pharmaceutical applications.",
    indianNames: {
      Hindi: "Mirch, Lal Mirch",
      Bengali: "Lanka",
      Gujarati: "Marcha",
      Kannada: "Menasinkai",
      Malayalam: "Mulaku",
      Marathi: "Mirchi",
      Tamil: "Milagai",
      Telugu: "Mirapa"
    },
    foreignNames: {
      Arabic: "Filfil Ahmar",
      French: "Piment",
      German: "Chili",
      Japanese: "Togarashi",
      Spanish: "Chile"
    },
    category: "major"
  },
  {
    id: "ginger",
    name: "Ginger",
    botanicalName: "Zingiber officinale",
    family: "Zingiberaceae",
    commercialPart: "Rhizome",
    image: "ginger",
    description: "Ginger is a perennial herb with thick, branching rhizomes. The plant produces erect, leafy shoots up to 1 meter tall with narrow, lance-shaped leaves. The rhizome has a pungent, spicy flavor with citrus notes. Fresh ginger is juicy with a mild heat, while dried ginger is more pungent.",
    origin: "Native to Southeast Asia, likely Southern China or India. India is a major producer, with Kerala, Karnataka, and Northeast states being key growing regions. It requires a warm, humid climate with temperatures of 25-35°C and annual rainfall of 1500-3000mm.",
    uses: "Ginger is used fresh, dried, pickled, preserved, crystallized, or powdered. It's essential in Asian cuisines, beverages (ginger ale, tea), and baked goods. Medicinally, it treats nausea, aids digestion, reduces inflammation, and has antimicrobial properties. Ginger oil is used in perfumery.",
    indianNames: {
      Hindi: "Adrak (fresh), Sonth (dry)",
      Bengali: "Ada",
      Gujarati: "Adu",
      Kannada: "Shunti",
      Malayalam: "Inchi",
      Marathi: "Ale",
      Tamil: "Inji",
      Telugu: "Allam"
    },
    foreignNames: {
      Arabic: "Zanjabil",
      French: "Gingembre",
      German: "Ingwer",
      Japanese: "Shoga",
      Chinese: "Jiang"
    },
    category: "major"
  },
  {
    id: "coriander",
    name: "Coriander",
    botanicalName: "Coriandrum sativum",
    family: "Apiaceae",
    commercialPart: "Fruit (seed), Leaves",
    image: "coriander",
    description: "Coriander is an annual herb growing 25-50 cm tall with branched stems. The lower leaves are broad and lobed, while upper leaves are finely divided. Small white or pale pink flowers form in compound umbels. The spherical fruits have a warm, nutty, slightly citrus flavor distinct from the fresh leaves.",
    origin: "Native to the Mediterranean and Western Asia. India is the world's largest producer, with Rajasthan, Gujarat, Madhya Pradesh, and Andhra Pradesh being major states. It grows in subtropical climates with moderate temperatures and requires well-drained soil.",
    uses: "Coriander seeds are used whole or ground in spice blends, curries, pickles, and baked goods. Fresh leaves (cilantro) garnish dishes globally. The essential oil is used in perfumery and food flavoring. Seeds aid digestion, reduce cholesterol, and have antioxidant properties.",
    indianNames: {
      Hindi: "Dhania",
      Bengali: "Dhane",
      Gujarati: "Dhana",
      Kannada: "Kothambari",
      Malayalam: "Malli",
      Marathi: "Dhane",
      Tamil: "Kothamalli",
      Telugu: "Dhaniyalu"
    },
    foreignNames: {
      Arabic: "Kuzbara",
      French: "Coriandre",
      German: "Koriander",
      Persian: "Gashneez",
      Spanish: "Cilantro"
    },
    category: "major"
  },
  {
    id: "cinnamon",
    name: "Cinnamon",
    botanicalName: "Cinnamomum verum",
    family: "Lauraceae",
    commercialPart: "Bark, Leaf",
    image: "cinnamon",
    description: "True cinnamon comes from an evergreen tree that can grow up to 10-15 meters but is cultivated as a bush. The dried inner bark is rolled into quills with a delicate, sweet flavor. The bark is thin, smooth, and light brown. Ceylon cinnamon has a subtle, complex flavor compared to cassia.",
    origin: "Native to Sri Lanka, also cultivated in Madagascar and Seychelles. In India, it grows in Kerala. It thrives in tropical conditions at elevations of 300-350 meters with temperatures of 20-30°C and rainfall of 1250-2500mm annually.",
    uses: "Cinnamon is used in both sweet and savory dishes, beverages, and baked goods. Available as quills, powder, or essential oil. It flavors confectionery, liquors, and pharmaceuticals. It helps regulate blood sugar, has anti-inflammatory properties, and aids digestion.",
    indianNames: {
      Hindi: "Dalchini",
      Bengali: "Dalchini",
      Gujarati: "Dalchini",
      Kannada: "Lavangapattai",
      Malayalam: "Karuvapatta",
      Marathi: "Dalchini",
      Tamil: "Karuvapattai",
      Telugu: "Dalchina Chekka"
    },
    foreignNames: {
      Arabic: "Querfa",
      French: "Cannelle",
      German: "Zimt",
      Persian: "Darchin",
      Spanish: "Canela"
    },
    category: "major"
  },
  {
    id: "clove",
    name: "Clove",
    botanicalName: "Syzygium aromaticum",
    family: "Myrtaceae",
    commercialPart: "Flower bud",
    image: "clove",
    description: "Cloves are the dried, unopened flower buds of an evergreen tree that can reach 10-12 meters. The buds are picked when pink and dried until dark brown. They have a strong, pungent, sweet flavor with a numbing quality. High-quality cloves sink in water due to their oil content.",
    origin: "Native to the Maluku Islands of Indonesia. Now cultivated in Zanzibar, Madagascar, Sri Lanka, and India (Kerala and Tamil Nadu). Trees begin flowering after 7 years and continue for decades. They require tropical maritime climate with high humidity.",
    uses: "Cloves are used whole or ground in spice blends, meat dishes, pickles, and baked goods. Essential in garam masala and Chinese five-spice. Clove oil is used in dentistry for its analgesic properties. It has antiseptic, antioxidant, and digestive benefits.",
    indianNames: {
      Hindi: "Laung",
      Bengali: "Labanga",
      Gujarati: "Laving",
      Kannada: "Lavanga",
      Malayalam: "Grambu",
      Marathi: "Lavang",
      Tamil: "Kirambu",
      Telugu: "Lavangalu"
    },
    foreignNames: {
      Arabic: "Qaranful",
      French: "Clou de Girofle",
      German: "Gewürznelke",
      Indonesian: "Cengkeh",
      Spanish: "Clavo"
    },
    category: "major"
  },
  {
    id: "nutmeg-mace",
    name: "Nutmeg & Mace",
    botanicalName: "Myristica fragrans",
    family: "Myristicaceae",
    commercialPart: "Seed (nutmeg), Aril (mace)",
    image: "nutmeg",
    description: "Nutmeg and mace come from the same fruit of an evergreen tree growing 9-12 meters tall. The fruit contains a single seed (nutmeg) covered by a red, lacy aril (mace). Nutmeg has a warm, sweet, slightly nutty flavor, while mace is more delicate with similar but subtler notes.",
    origin: "Native to the Banda Islands of Indonesia. Cultivated in Grenada, Sri Lanka, and India (Kerala and Tamil Nadu). Trees are dioecious and begin bearing fruit after 7-9 years. They require tropical climates with temperatures of 20-30°C and high rainfall.",
    uses: "Nutmeg flavors baked goods, custards, and beverages like eggnog. Mace is used in savory dishes, sauces, and pickles. Both are components of spice blends. The essential oils are used in perfumery and pharmaceuticals. They aid digestion and have sedative properties in small amounts.",
    indianNames: {
      Hindi: "Jaiphal (nutmeg), Javitri (mace)",
      Bengali: "Jaiphal, Javitri",
      Gujarati: "Jaiphal, Javetri",
      Kannada: "Jajikai, Japatri",
      Malayalam: "Jathikka, Jathipathri",
      Marathi: "Jaiphal, Jaypatri",
      Tamil: "Jathikkai, Jathipatri",
      Telugu: "Jajikaya, Japathri"
    },
    foreignNames: {
      Arabic: "Joz at-Tib",
      French: "Muscade, Macis",
      German: "Muskatnuss, Muskatblüte",
      Dutch: "Nootmuskaat",
      Spanish: "Nuez Moscada"
    },
    category: "major"
  },
  {
    id: "fennel",
    name: "Fennel",
    botanicalName: "Foeniculum vulgare",
    family: "Apiaceae",
    commercialPart: "Fruit (seed)",
    image: "fennel",
    description: "Fennel is a hardy perennial herb growing 1.5-2 meters tall with feathery, thread-like leaves. The plant produces yellow flowers in large compound umbels. The seeds are greenish-yellow, elongated, and ridged with a sweet, anise-like flavor. Both seeds and fronds are used culinarily.",
    origin: "Native to the Mediterranean region. India is a major producer, with Gujarat and Rajasthan being primary growing states. It adapts to various climates but prefers mild temperatures and well-drained soil. It can tolerate some drought.",
    uses: "Fennel seeds are used in spice blends, bread, sausages, and fish dishes. They're chewed after meals as a digestive aid and breath freshener. The bulb is eaten as a vegetable. Essential oil is used in perfumery and pharmaceuticals. It aids digestion and has antispasmodic properties.",
    indianNames: {
      Hindi: "Saunf",
      Bengali: "Mouri",
      Gujarati: "Variyali",
      Kannada: "Badisoppu",
      Malayalam: "Perumjeerakam",
      Marathi: "Badishep",
      Tamil: "Sombu",
      Telugu: "Sopu"
    },
    foreignNames: {
      Arabic: "Shamra",
      French: "Fenouil",
      German: "Fenchel",
      Italian: "Finocchio",
      Spanish: "Hinojo"
    },
    category: "seed"
  },
  {
    id: "fenugreek",
    name: "Fenugreek",
    botanicalName: "Trigonella foenum-graecum",
    family: "Fabaceae",
    commercialPart: "Seed, Leaves",
    image: "fenugreek",
    description: "Fenugreek is an annual herb growing 30-60 cm tall with trifoliate leaves and white flowers. The pods are long and slender, containing 10-20 small, hard, yellowish-brown seeds. The seeds have a distinctive maple syrup-like aroma when cooked and a bitter taste when raw.",
    origin: "Native to the Mediterranean and Western Asia. India is the largest producer, with Rajasthan, Gujarat, and Madhya Pradesh being major growing states. It grows in semi-arid regions with moderate temperatures and is often grown as a winter crop.",
    uses: "Fenugreek seeds are used in curry powders, pickles, and spice blends. Fresh and dried leaves (kasuri methi) are popular in Indian cuisine. The seeds are used in traditional medicine for diabetes management and lactation support. Extracts are used in maple syrup flavoring.",
    indianNames: {
      Hindi: "Methi",
      Bengali: "Methi",
      Gujarati: "Methi",
      Kannada: "Menthya",
      Malayalam: "Uluva",
      Marathi: "Methi",
      Tamil: "Vendayam",
      Telugu: "Mentulu"
    },
    foreignNames: {
      Arabic: "Hulba",
      French: "Fenugrec",
      German: "Bockshornklee",
      Greek: "Trigonella",
      Persian: "Shanbalileh"
    },
    category: "seed"
  },
  {
    id: "mustard",
    name: "Mustard",
    botanicalName: "Brassica juncea / Brassica nigra",
    family: "Brassicaceae",
    commercialPart: "Seed",
    image: "mustard",
    description: "Mustard plants are annual herbs with yellow flowers and seed pods. Three species are commercially important: black mustard (B. nigra), brown/Indian mustard (B. juncea), and white/yellow mustard (Sinapis alba). Seeds are small, round, and range from yellow to dark brown, with pungent flavor when crushed.",
    origin: "Various origins depending on species. Brown mustard is likely from the Himalayan region. India is a major producer, with Rajasthan, Uttar Pradesh, and Madhya Pradesh being key states. It grows well in cool, moist conditions and is primarily a winter crop.",
    uses: "Mustard seeds are used whole for tempering in Indian cooking, ground for condiments, and pressed for oil. Mustard paste and prepared mustard are condiments worldwide. The oil is used for cooking and massage. Seeds have antimicrobial properties and stimulate digestion.",
    indianNames: {
      Hindi: "Sarson, Rai",
      Bengali: "Sorisha",
      Gujarati: "Rai",
      Kannada: "Sasive",
      Malayalam: "Kaduku",
      Marathi: "Mohari",
      Tamil: "Kadugu",
      Telugu: "Avalu"
    },
    foreignNames: {
      Arabic: "Khardal",
      French: "Moutarde",
      German: "Senf",
      Japanese: "Karashi",
      Spanish: "Mostaza"
    },
    category: "seed"
  },
  {
    id: "saffron",
    name: "Saffron",
    botanicalName: "Crocus sativus",
    family: "Iridaceae",
    commercialPart: "Stigma",
    image: "saffron",
    description: "Saffron is the world's most expensive spice by weight, derived from the stigmas of a small purple crocus. Each flower produces only three stigmas, which must be hand-harvested. The threads are deep red with a distinctive honey-like, slightly metallic flavor and intense color.",
    origin: "Native to Greece or Southwest Asia. In India, it's cultivated exclusively in Kashmir (Pampore region). Iran is the world's largest producer. It requires specific conditions: cold winters, hot dry summers, and well-drained soil at elevations of 1500-2500 meters.",
    uses: "Saffron is used to color and flavor rice dishes (biryani, paella, risotto), desserts, and beverages. Only a few threads are needed due to its potency. It has antioxidant properties and is used in traditional medicine for depression and inflammation. Also used in cosmetics and textiles.",
    indianNames: {
      Hindi: "Kesar, Zafran",
      Bengali: "Kesar",
      Gujarati: "Kesar",
      Kannada: "Kesar",
      Malayalam: "Kumkumapoo",
      Marathi: "Kesar",
      Tamil: "Kungumapoo",
      Telugu: "Kumkuma Puvvu"
    },
    foreignNames: {
      Arabic: "Zafaran",
      French: "Safran",
      German: "Safran",
      Persian: "Zafaran",
      Spanish: "Azafrán"
    },
    category: "premium"
  },
  {
    id: "vanilla",
    name: "Vanilla",
    botanicalName: "Vanilla planifolia",
    family: "Orchidaceae",
    commercialPart: "Fruit (pod/bean)",
    image: "vanilla",
    description: "Vanilla is a climbing orchid vine that can grow over 30 meters. The green pods (beans) are harvested unripe and undergo a lengthy curing process to develop their characteristic aroma. Cured beans are dark brown, flexible, and covered with vanillin crystals. The flavor is sweet, creamy, and complex.",
    origin: "Native to Mexico and Central America. Madagascar is the world's largest producer. In India, it's grown in Karnataka, Kerala, and Tamil Nadu. It requires tropical conditions with temperatures of 25-30°C, high humidity, and partial shade, typically grown on support trees.",
    uses: "Vanilla is the world's most popular flavor, used in ice cream, baked goods, beverages, and perfumes. Available as whole beans, extract, powder, or paste. Synthetic vanillin is widely used but lacks the complexity of natural vanilla. It has antioxidant and potentially calming properties.",
    indianNames: {
      Hindi: "Vanilla",
      Bengali: "Vanilla",
      Gujarati: "Vanilla",
      Kannada: "Vanilla",
      Malayalam: "Vanilla",
      Marathi: "Vanilla",
      Tamil: "Vanilla",
      Telugu: "Vanilla"
    },
    foreignNames: {
      Arabic: "Fanilya",
      French: "Vanille",
      German: "Vanille",
      Spanish: "Vainilla",
      Japanese: "Banira"
    },
    category: "premium"
  },
  {
    id: "star-anise",
    name: "Star Anise",
    botanicalName: "Illicium verum",
    family: "Schisandraceae",
    commercialPart: "Fruit",
    image: "star-anise",
    description: "Star anise is the star-shaped fruit of an evergreen tree growing 8-15 meters tall. The fruit consists of 6-8 pointed segments (carpels), each containing a shiny seed. It has a strong, sweet, licorice-like flavor similar to aniseed but more intense. The whole fruit is very aromatic.",
    origin: "Native to Southwest China and Northeast Vietnam. China remains the primary producer. In India, it's grown in limited quantities in Arunachal Pradesh. It requires subtropical to warm temperate climates with temperatures not dropping below -10°C.",
    uses: "Star anise is essential in Chinese five-spice powder and Vietnamese pho. Used whole or ground in braised dishes, desserts, and beverages. It's the primary source of shikimic acid used in antiviral medications. Has carminative and antimicrobial properties.",
    indianNames: {
      Hindi: "Chakri Phool",
      Bengali: "Chakri Phul",
      Gujarati: "Anasphal",
      Kannada: "Chakke Hu",
      Malayalam: "Takkolam",
      Marathi: "Badian",
      Tamil: "Annasi Poo",
      Telugu: "Anaspuvu"
    },
    foreignNames: {
      Arabic: "Yansoon Najmi",
      French: "Anis Étoilé",
      German: "Sternanis",
      Chinese: "Ba Jiao",
      Vietnamese: "Hồi"
    },
    category: "aromatic"
  },
  {
    id: "bay-leaf",
    name: "Bay Leaf",
    botanicalName: "Laurus nobilis",
    family: "Lauraceae",
    commercialPart: "Leaf",
    image: "bay-leaf",
    description: "Bay leaves come from an evergreen tree or large shrub that can reach 15-20 meters. The leaves are elliptical, dark green, glossy on top, and have a subtle, herbal, slightly floral aroma. Fresh leaves are bitter; drying develops their characteristic flavor. Indian bay leaf (tejpat) is from a different species.",
    origin: "Native to the Mediterranean region. Cultivated in Turkey, France, and other Mediterranean countries. In India, tejpat (Cinnamomum tamala) serves a similar purpose and grows in the Himalayas. True bay laurel prefers Mediterranean climates with mild winters.",
    uses: "Bay leaves are used to flavor soups, stews, braises, and rice dishes. They're always removed before serving. Essential in bouquet garni and many spice blends. The essential oil is used in perfumery. Bay has mild antiseptic and digestive properties.",
    indianNames: {
      Hindi: "Tej Patta",
      Bengali: "Tej Pata",
      Gujarati: "Tamalpatra",
      Kannada: "Masala Ele",
      Malayalam: "Karuva Ela",
      Marathi: "Tamal Patra",
      Tamil: "Brinji Ilai",
      Telugu: "Akupatri"
    },
    foreignNames: {
      Arabic: "Waraq al Gar",
      French: "Laurier",
      German: "Lorbeerblatt",
      Italian: "Alloro",
      Spanish: "Laurel"
    },
    category: "leaf"
  },
  {
    id: "asafoetida",
    name: "Asafoetida",
    botanicalName: "Ferula assa-foetida",
    family: "Apiaceae",
    commercialPart: "Gum resin",
    image: "asafoetida",
    description: "Asafoetida is a dried gum resin extracted from the rhizome and roots of giant fennel plants. The raw resin has an extremely pungent, sulfurous odor that mellows significantly when cooked, becoming savory and umami-rich. It's sold as lumps, powder, or compounded with edible gum.",
    origin: "Native to Iran and Afghanistan. The plant grows wild in arid regions of Central Asia. India is the largest consumer but produces very little domestically, importing primarily from Afghanistan and Iran. It grows at high altitudes in dry, rocky soil.",
    uses: "Asafoetida is essential in Indian vegetarian cooking, particularly South Indian cuisine, providing a savory depth similar to onions and garlic. Used in very small quantities due to its potency. It aids digestion, reduces flatulence, and is used in Ayurvedic medicine.",
    indianNames: {
      Hindi: "Hing",
      Bengali: "Hing",
      Gujarati: "Hing",
      Kannada: "Ingu",
      Malayalam: "Kayam",
      Marathi: "Hing",
      Tamil: "Perungayam",
      Telugu: "Inguva"
    },
    foreignNames: {
      Arabic: "Hiltit",
      French: "Ase Fétide",
      German: "Asant",
      Persian: "Anguzeh",
      Spanish: "Asafétida"
    },
    category: "resin"
  },
  {
    id: "tamarind",
    name: "Tamarind",
    botanicalName: "Tamarindus indica",
    family: "Fabaceae",
    commercialPart: "Fruit pulp",
    image: "tamarind",
    description: "Tamarind is a large evergreen tree growing up to 25 meters with a dense crown. The fruit is a brown pod containing sticky, acidic pulp surrounding hard seeds. The pulp has a sweet-sour flavor and is rich in tartaric acid. Young pods are more sour; ripe pods develop sweetness.",
    origin: "Native to tropical Africa but naturalized in India for millennia. India is a major producer and consumer. It grows throughout tropical India, particularly Tamil Nadu, Andhra Pradesh, Karnataka, and Maharashtra. It tolerates drought and poor soils.",
    uses: "Tamarind pulp is used as a souring agent in chutneys, sauces, curries, and beverages. It's essential in Worcestershire sauce, pad Thai, and rasam. Available as whole pods, pressed blocks, paste, or concentrate. It has laxative properties and is rich in vitamins and minerals.",
    indianNames: {
      Hindi: "Imli",
      Bengali: "Tentul",
      Gujarati: "Ambli",
      Kannada: "Hunase",
      Malayalam: "Puli",
      Marathi: "Chinch",
      Tamil: "Puli",
      Telugu: "Chintapandu"
    },
    foreignNames: {
      Arabic: "Tamar Hindi",
      French: "Tamarin",
      German: "Tamarinde",
      Spanish: "Tamarindo",
      Thai: "Makham"
    },
    category: "fruit"
  },
  {
    id: "curry-leaf",
    name: "Curry Leaf",
    botanicalName: "Murraya koenigii",
    family: "Rutaceae",
    commercialPart: "Leaf",
    image: "curry-leaf",
    description: "Curry leaf comes from a small aromatic tree growing up to 6 meters. The pinnate leaves have 11-21 leaflets with a distinctive curry-like aroma. Fresh leaves have the best flavor; dried leaves lose much of their potency. The flavor is complex with citrus and nutty notes.",
    origin: "Native to India and Sri Lanka. Cultivated throughout South and Southeast Asia. In India, it grows abundantly in the south and is often found in home gardens. It prefers tropical to subtropical climates and is relatively easy to cultivate.",
    uses: "Curry leaves are essential in South Indian cooking, used fresh for tempering (tadka) in dals, curries, and chutneys. They're also used in Ayurvedic medicine for diabetes management and digestive health. The leaves have antioxidant properties and are believed to promote hair growth.",
    indianNames: {
      Hindi: "Kari Patta, Meetha Neem",
      Bengali: "Barsunga Pata",
      Gujarati: "Mitho Limbdo",
      Kannada: "Karibevu",
      Malayalam: "Kariveppila",
      Marathi: "Kadhi Patta",
      Tamil: "Karuveppilai",
      Telugu: "Karivepaku"
    },
    foreignNames: {
      Sinhalese: "Karapincha",
      Thai: "Bai Karee",
      Malay: "Daun Kari",
      Indonesian: "Salam Koja"
    },
    category: "leaf"
  },
  {
    id: "garlic",
    name: "Garlic",
    botanicalName: "Allium sativum",
    family: "Amaryllidaceae",
    commercialPart: "Bulb",
    image: "garlic",
    description: "Garlic is a bulbous perennial plant growing 30-60 cm tall. The bulb consists of multiple cloves enclosed in a papery skin. Raw garlic has an intense, pungent flavor that becomes milder and sweeter when cooked. Varieties range from mild to very pungent, and white to purple.",
    origin: "Native to Central Asia. China is the world's largest producer. India is a significant producer, with Madhya Pradesh, Gujarat, and Rajasthan being major states. It grows as a cool-season crop preferring temperatures of 13-24°C.",
    uses: "Garlic is a fundamental flavoring in cuisines worldwide. Used fresh, dried, powdered, or as paste. It's essential in countless savory dishes, sauces, and condiments. Garlic has potent medicinal properties including cardiovascular benefits, antimicrobial action, and immune support.",
    indianNames: {
      Hindi: "Lahsun",
      Bengali: "Rasun",
      Gujarati: "Lasan",
      Kannada: "Bellulli",
      Malayalam: "Veluthulli",
      Marathi: "Lasun",
      Tamil: "Poondu",
      Telugu: "Velluli"
    },
    foreignNames: {
      Arabic: "Thoom",
      French: "Ail",
      German: "Knoblauch",
      Italian: "Aglio",
      Spanish: "Ajo"
    },
    category: "bulb"
  },
  {
    id: "poppy-seed",
    name: "Poppy Seed",
    botanicalName: "Papaver somniferum",
    family: "Papaveraceae",
    commercialPart: "Seed",
    image: "poppy-seed",
    description: "Poppy seeds are tiny, kidney-shaped seeds from the opium poppy plant. The seeds themselves contain negligible alkaloids and are completely safe for culinary use. They come in white, blue, and black varieties. The flavor is mild, nutty, and slightly sweet.",
    origin: "Native to the Eastern Mediterranean. Cultivated in various countries including India (Madhya Pradesh, Rajasthan, Uttar Pradesh), Turkey, and European countries. It's a cool-weather crop harvested when pods are mature and seeds rattle inside.",
    uses: "White poppy seeds are used in Indian cooking to thicken curries and add richness. Blue/black seeds are popular in European and Middle Eastern baking (bagels, pastries). Seeds are pressed for oil. They provide calcium, iron, and zinc. Have mild sedative properties in large amounts.",
    indianNames: {
      Hindi: "Khus Khus, Posto",
      Bengali: "Posto",
      Gujarati: "Khus Khus",
      Kannada: "Gasagase",
      Malayalam: "Kasakasa",
      Marathi: "Khashkhash",
      Tamil: "Kasakasa",
      Telugu: "Gasagasalu"
    },
    foreignNames: {
      Arabic: "Khashkhash",
      French: "Pavot",
      German: "Mohn",
      Polish: "Mak",
      Turkish: "Haşhaş"
    },
    category: "seed"
  },
  {
    id: "caraway",
    name: "Caraway Seed",
    botanicalName: "Carum carvi",
    family: "Apiaceae",
    commercialPart: "Fruit (seed)",
    image: "caraway",
    description: "Caraway is a biennial herb growing 30-60 cm tall with finely divided leaves. The fruits are crescent-shaped with five ridges and have a warm, slightly anise-like flavor with earthy, peppery notes. Often confused with cumin, caraway has a distinctly different, sweeter taste.",
    origin: "Native to Western Asia and Europe. Cultivated in Netherlands, Poland, Germany, and North Africa. In India, it's grown in limited quantities in cooler regions. It prefers cool climates with temperatures of 15-25°C.",
    uses: "Caraway seeds flavor rye bread, sauerkraut, cheeses, and liqueurs (kümmel, aquavit). Used in European and North African cuisines in meat dishes, cabbage recipes, and baked goods. The seeds aid digestion and have carminative properties.",
    indianNames: {
      Hindi: "Shahi Jeera, Kala Jeera",
      Bengali: "Shahi Jeera",
      Gujarati: "Shahjeeru",
      Kannada: "Shah Jeerige",
      Malayalam: "Shima Jeerakam",
      Tamil: "Shimaisombu",
      Telugu: "Shima Jilakarra"
    },
    foreignNames: {
      Arabic: "Karawiya",
      French: "Carvi",
      German: "Kümmel",
      Dutch: "Karwij",
      Swedish: "Kummin"
    },
    category: "seed"
  },
  {
    id: "celery-seed",
    name: "Celery",
    botanicalName: "Apium graveolens",
    family: "Apiaceae",
    commercialPart: "Seed, Stalk, Leaves",
    image: "celery",
    description: "Celery is an aromatic biennial herb grown for its stalks, leaves, and seeds. The seeds are tiny, light brown, and have a concentrated celery flavor - warm, bitter, and slightly citrusy. The stalks are crisp and watery with a mild, fresh taste.",
    origin: "Native to the Mediterranean and Middle East. Cultivated worldwide for various parts. In India, it's grown in Punjab, Uttar Pradesh, and Himachal Pradesh, primarily for seeds. It prefers cool, moist conditions.",
    uses: "Celery seeds flavor pickles, soups, and vegetable dishes. Celery salt combines ground seeds with salt. Stalks are eaten raw or cooked in countless dishes. The essential oil is used in perfumery. Seeds have diuretic properties and may help with blood pressure.",
    indianNames: {
      Hindi: "Ajwain Ka Phool",
      Bengali: "Randhuni",
      Gujarati: "Ajmoda",
      Kannada: "Ajamoda",
      Malayalam: "Ayamodakam",
      Tamil: "Ajmud",
      Telugu: "Vamaku"
    },
    foreignNames: {
      Arabic: "Karafs",
      French: "Céleri",
      German: "Sellerie",
      Italian: "Sedano",
      Spanish: "Apio"
    },
    category: "seed"
  },
  {
    id: "dill",
    name: "Dill",
    botanicalName: "Anethum graveolens",
    family: "Apiaceae",
    commercialPart: "Seed, Leaves",
    image: "dill",
    description: "Dill is an annual herb growing 40-60 cm tall with feathery, fern-like leaves and yellow flowers. The seeds are flat, oval, and light brown with a warm, slightly bitter flavor. Fresh dill weed has a sweet, grassy taste. Both have pleasant aromatic properties.",
    origin: "Native to the Mediterranean and Western Asia. Cultivated in Europe, North America, and Asia. In India, it's grown in Punjab and Gujarat. It prefers cool weather and full sun.",
    uses: "Dill seeds flavor pickles, breads, and fish dishes. Fresh dill weed is essential in Scandinavian and Eastern European cuisines with salmon, potatoes, and yogurt sauces. The essential oil is used in food and cosmetics. Dill aids digestion and has calming properties.",
    indianNames: {
      Hindi: "Sowa, Suva",
      Bengali: "Sholpa",
      Gujarati: "Suva",
      Kannada: "Sabbasige",
      Malayalam: "Sathakuppa",
      Marathi: "Shepu",
      Tamil: "Sathaputhi",
      Telugu: "Soya Kura"
    },
    foreignNames: {
      Arabic: "Shabbat",
      French: "Aneth",
      German: "Dill",
      Russian: "Ukrop",
      Swedish: "Dill"
    },
    category: "herb"
  },
  {
    id: "sesame",
    name: "Sesame",
    botanicalName: "Sesamum indicum",
    family: "Pedaliaceae",
    commercialPart: "Seed",
    image: "sesame",
    description: "Sesame is an annual flowering plant growing 50-100 cm tall. The seeds are small, flat, and oval, available in white, golden, brown, and black varieties. They have a delicate, nutty flavor that intensifies when toasted. The seeds have one of the highest oil contents of any seed.",
    origin: "One of the oldest oilseed crops, native to Africa or India. Cultivated in India, China, Sudan, and Myanmar. In India, it's grown in Gujarat, Rajasthan, West Bengal, and Tamil Nadu. It tolerates drought and grows in tropical to temperate climates.",
    uses: "Sesame seeds are used whole on breads and in cooking, ground into tahini or paste, and pressed for oil. Essential in Middle Eastern, Asian, and Indian cuisines. Sesame oil is used for cooking and massage. Seeds are rich in calcium, iron, and healthy fats.",
    indianNames: {
      Hindi: "Til",
      Bengali: "Til",
      Gujarati: "Tal",
      Kannada: "Ellu",
      Malayalam: "Ellu",
      Marathi: "Til",
      Tamil: "Ellu",
      Telugu: "Nuvvulu"
    },
    foreignNames: {
      Arabic: "Simsim",
      French: "Sésame",
      German: "Sesam",
      Japanese: "Goma",
      Chinese: "Zhima"
    },
    category: "seed"
  },
  {
    id: "ajwain",
    name: "Ajwain (Carom)",
    botanicalName: "Trachyspermum ammi",
    family: "Apiaceae",
    commercialPart: "Fruit (seed)",
    image: "ajwain",
    description: "Ajwain is an annual herb similar to parsley, growing 30-90 cm tall. The small, oval seeds are grayish-brown with ridges and have an intensely aromatic, thyme-like flavor due to high thymol content. The taste is sharp, pungent, and slightly bitter.",
    origin: "Native to the Eastern Mediterranean and Western Asia. India is the world's largest producer and consumer, with Rajasthan and Gujarat being major states. It grows in arid and semi-arid regions.",
    uses: "Ajwain is essential in Indian cooking, particularly in fried foods, breads (parathas, puris), and legume dishes where it aids digestion. Often used in tempering. It's a powerful carminative and digestive aid. The essential oil has antimicrobial properties.",
    indianNames: {
      Hindi: "Ajwain",
      Bengali: "Jowan",
      Gujarati: "Ajmo",
      Kannada: "Oma",
      Malayalam: "Omam",
      Marathi: "Ova",
      Tamil: "Omam",
      Telugu: "Vamu"
    },
    foreignNames: {
      Arabic: "Nankhah",
      Persian: "Zenyan",
      Urdu: "Ajwain"
    },
    category: "seed"
  },
  {
    id: "nigella",
    name: "Nigella (Kalonji)",
    botanicalName: "Nigella sativa",
    family: "Ranunculaceae",
    commercialPart: "Seed",
    image: "nigella",
    description: "Nigella is an annual flowering plant growing 20-30 cm tall with delicate blue or white flowers. The small, matte black seeds are triangular with a rough texture. They have a complex flavor - slightly bitter, peppery, with notes of oregano and onion.",
    origin: "Native to South and Southwest Asia. Cultivated in India, Egypt, and Middle Eastern countries. In India, it's grown in Bihar, West Bengal, and Assam. It grows in subtropical climates.",
    uses: "Nigella seeds are used in Indian breads (naan), pickles, and curries. Popular in Middle Eastern and Central Asian cuisines. Known as 'black cumin' in some regions (though unrelated to cumin). Has numerous medicinal uses in traditional medicine including immune support.",
    indianNames: {
      Hindi: "Kalonji",
      Bengali: "Kalo Jeera",
      Gujarati: "Kalonji",
      Kannada: "Krishna Jeerige",
      Malayalam: "Karinjirakam",
      Marathi: "Kalonji",
      Tamil: "Karunjeeragam",
      Telugu: "Nalla Jeelakarra"
    },
    foreignNames: {
      Arabic: "Habbatus Sauda",
      French: "Nigelle",
      German: "Schwarzkümmel",
      Turkish: "Çörek Otu",
      Persian: "Siah Daneh"
    },
    category: "seed"
  },
  {
    id: "kokum",
    name: "Kokum",
    botanicalName: "Garcinia indica",
    family: "Clusiaceae",
    commercialPart: "Fruit rind",
    image: "kokum",
    description: "Kokum is an evergreen tree growing up to 18 meters with a dense crown. The fruit is round, deep purple when ripe, with a tangy, slightly sweet flavor. The dried rind is dark purple to black with a pleasant, fruity acidity. It's a key souring agent in Konkani cuisine.",
    origin: "Endemic to the Western Ghats of India, particularly the Konkan coast (Maharashtra, Goa, Karnataka, Kerala). It grows in tropical evergreen forests and is often cultivated in home gardens. It requires humid tropical conditions.",
    uses: "Kokum is used to add sourness to curries, especially fish preparations in coastal cuisine. Kokum sherbet is a popular cooling drink. The fruit contains hydroxycitric acid (HCA), studied for weight management. Kokum butter from seeds is used in cosmetics and chocolates.",
    indianNames: {
      Hindi: "Kokum",
      Konkani: "Bhirinda",
      Kannada: "Murgina Hannu",
      Malayalam: "Punampuli",
      Marathi: "Kokum, Ratamba"
    },
    foreignNames: {
      English: "Cocum, Mangosteen (though different from purple mangosteen)"
    },
    category: "regional"
  },
  {
    id: "aniseed",
    name: "Aniseed",
    botanicalName: "Pimpinella anisum",
    family: "Apiaceae",
    commercialPart: "Fruit (seed)",
    image: "aniseed",
    description: "Aniseed comes from an annual herb growing 30-50 cm tall with feathery leaves and small white flowers. The small, grayish-green seeds have a distinctive sweet, licorice-like flavor. Often confused with star anise or fennel, though each has distinct characteristics.",
    origin: "Native to the Eastern Mediterranean and Southwest Asia. Cultivated in Spain, Turkey, Egypt, and parts of Asia. In India, it's grown in limited quantities. It prefers warm, sunny climates with well-drained soil.",
    uses: "Aniseed flavors liqueurs (ouzo, pastis, sambuca), baked goods, and confectionery. Used in Mediterranean and Middle Eastern cuisines. The essential oil is used in perfumery and pharmaceuticals. It has carminative, expectorant, and mild sedative properties.",
    indianNames: {
      Hindi: "Vilayati Saunf",
      Bengali: "Mouri",
      Gujarati: "Anisi",
      Tamil: "Sombu",
      Telugu: "Sompu"
    },
    foreignNames: {
      Arabic: "Yansoon",
      French: "Anis",
      German: "Anis",
      Greek: "Anison",
      Spanish: "Anís"
    },
    category: "seed"
  },
  {
    id: "cardamom-large",
    name: "Cardamom (Large)",
    botanicalName: "Amomum subulatum",
    family: "Zingiberaceae",
    commercialPart: "Fruit (capsule)",
    image: "cardamom-large",
    description: "Large cardamom, also called black cardamom, comes from a perennial herb growing 1.5-3 meters tall. The pods are larger and darker than green cardamom with a distinctive smoky, camphor-like aroma from the drying process. The flavor is bold and assertive.",
    origin: "Native to the Eastern Himalayas. Sikkim and Darjeeling in India are major producers. Also grown in Nepal and Bhutan. It grows in shaded, moist conditions at elevations of 800-2000 meters.",
    uses: "Large cardamom is used in robust meat dishes, biryanis, and spice blends in North Indian cooking. Essential in garam masala. The smoky flavor pairs well with rich, slow-cooked dishes. It aids digestion and has warming properties in traditional medicine.",
    indianNames: {
      Hindi: "Badi Elaichi, Moti Elaichi",
      Bengali: "Boro Elach",
      Gujarati: "Moti Elchi",
      Nepali: "Alainchi",
      Punjabi: "Moti Elaichi"
    },
    foreignNames: {
      Arabic: "Haal Aswad",
      Chinese: "Cao Guo",
      Thai: "Kravan"
    },
    category: "major"
  },
  {
    id: "cassia",
    name: "Cassia",
    botanicalName: "Cinnamomum cassia",
    family: "Lauraceae",
    commercialPart: "Bark",
    image: "cassia",
    description: "Cassia, also called Chinese cinnamon, comes from an evergreen tree growing 10-15 meters tall. The bark is thicker, darker, and more strongly flavored than true cinnamon, with a single-layered quill. It has a more pungent, less delicate flavor with higher coumarin content.",
    origin: "Native to Southern China and Southeast Asia. Major producer is China, with Vietnam and Indonesia also significant. It grows in tropical and subtropical regions with monsoon climates.",
    uses: "Cassia is the common 'cinnamon' in North America and Asia. Used in baking, beverages, and savory dishes. Essential in Chinese five-spice. Often used interchangeably with true cinnamon, though the flavor is more intense. Has similar but stronger medicinal properties.",
    indianNames: {
      Hindi: "Jangli Dalchini",
      Bengali: "Dalchini",
      Gujarati: "Taj",
      Kannada: "Dalchini",
      Tamil: "Lavangapattai"
    },
    foreignNames: {
      Chinese: "Gui Zhi",
      French: "Casse",
      German: "Kassia",
      Vietnamese: "Quế",
      Indonesian: "Kayu Manis"
    },
    category: "bark"
  },
  {
    id: "allspice",
    name: "Allspice",
    botanicalName: "Pimenta dioica",
    family: "Myrtaceae",
    commercialPart: "Dried unripe fruit",
    image: "allspice",
    description: "Allspice trees are evergreen medium-sized trees growing up to 8-10 meters with a slender upright trunk and smooth greyish bark. The dried unripe berries resemble large brown peppercorns. The name 'allspice' comes from its aroma, which resembles a combination of cinnamon, nutmeg, and cloves.",
    origin: "Native to the Greater Antilles, southern Mexico, and Central America. Jamaica is the primary producer, hence it's also called Jamaica pepper. It grows in tropical climates with consistent rainfall.",
    uses: "Used whole or ground in Caribbean cuisine, jerk seasoning, pickling, and baked goods. Essential in Jamaican cooking. The essential oil is used in perfumery and food flavoring. Has digestive and analgesic properties.",
    indianNames: {
      Hindi: "Kabab Chini",
      Bengali: "Gol Mirch",
      Tamil: "Sarva Sugandhi"
    },
    foreignNames: {
      French: "Piment de la Jamaïque",
      German: "Piment",
      Spanish: "Pimienta de Jamaica",
      Arabic: "Bahar Halu"
    },
    category: "aromatic"
  },
  {
    id: "basil",
    name: "Basil (Sweet Basil)",
    botanicalName: "Ocimum basilicum",
    family: "Lamiaceae",
    commercialPart: "Leaves",
    image: "basil",
    description: "Basil, also known as Sweet Basil or Tulsi, is an erect glabrous herb growing 30-90 cm high. The leaves have numerous oil glands with aromatic volatile oil. The plant is indigenous to India and has a strong, sweet, slightly peppery flavor with hints of anise.",
    origin: "Native to tropical regions from Central Africa to Southeast Asia. India is a major producer. Holy Basil (Tulsi) is sacred in Hindu culture. Grows well in warm, sunny conditions.",
    uses: "Essential in Italian cuisine (pesto, caprese), Thai cooking, and Vietnamese pho. Used fresh or dried. Has antibacterial, anti-inflammatory properties. Tulsi is used in Ayurvedic medicine for respiratory ailments and stress relief.",
    indianNames: {
      Hindi: "Tulsi, Babui Tulsi",
      Bengali: "Babui Tulsi",
      Gujarati: "Damro",
      Kannada: "Kamakasturi",
      Malayalam: "Tirunitru",
      Tamil: "Tirunitru",
      Telugu: "Bhutulasi"
    },
    foreignNames: {
      French: "Basilic",
      German: "Basilikum",
      Italian: "Basilico",
      Spanish: "Albahaca",
      Thai: "Horapha"
    },
    category: "herb"
  },
  {
    id: "cambodge",
    name: "Cambodge (Malabar Tamarind)",
    botanicalName: "Garcinia gummi-gutta",
    family: "Clusiaceae",
    commercialPart: "Fruit rind",
    image: "cambodge",
    description: "Cambodge is a tropical fruit commonly known as Malabar Tamarind. It is a medium-size evergreen dioecious tree with rounded crown and horizontal or drooping branches attaining a height of 5-20 meters. The fruit is yellow or red when ripe with deep vertical lobes.",
    origin: "Native to Indonesia and grows primarily in the Western Ghats of India, particularly Kerala and Karnataka. Thrives in tropical evergreen and semi-evergreen forests.",
    uses: "Used as a souring agent in South Indian and Sri Lankan cuisine, particularly in fish curries. Contains hydroxycitric acid (HCA), popular in weight loss supplements. Also used in Ayurvedic medicine.",
    indianNames: {
      Hindi: "Vilayti Imli",
      Malayalam: "Kudampuli",
      Kannada: "Uppage",
      Tamil: "Goraka",
      Konkani: "Ambot"
    },
    foreignNames: {
      English: "Malabar Tamarind",
      Sinhalese: "Goraka"
    },
    category: "regional"
  },
  {
    id: "caper",
    name: "Caper",
    botanicalName: "Capparis spinosa",
    family: "Capparaceae",
    commercialPart: "Flower buds",
    image: "caper",
    description: "Capers are the immature flower buds of a small shrub that reaches 1 meter in height. The plant has thick, shiny, rounded leaves and beautiful white-pink flowers. The buds are picked before flowering, then sun-dried and pickled in salt or brine.",
    origin: "Native to the Mediterranean region. Grows wild in rocky, arid conditions. Major producers include Morocco, Spain, Turkey, and Italy. The plant is drought-resistant and thrives in poor soil.",
    uses: "Used pickled as a condiment in Mediterranean cuisine. Essential in dishes like chicken piccata, putanesca sauce, and smoked salmon preparations. Adds a sharp, piquant flavor. Rich in antioxidants.",
    indianNames: {
      Hindi: "Kabra",
      Bengali: "Kabra"
    },
    foreignNames: {
      French: "Câpre",
      German: "Kaper",
      Italian: "Cappero",
      Spanish: "Alcaparra",
      Greek: "Kapari"
    },
    category: "aromatic"
  },
  {
    id: "greater-galangal",
    name: "Greater Galangal",
    botanicalName: "Alpinia galanga",
    family: "Zingiberaceae",
    commercialPart: "Rhizome",
    image: "galangal",
    description: "Greater Galangal is a perennial, robust, tillering, rhizomatous herb. The plant is 1.8-2.1 meters high with perennial rhizomes 2.5-10 cm in diameter. The rhizome has a pungent, ginger-like flavor with citrus and pine notes.",
    origin: "Native to Indonesia and possibly Southern China. Widely cultivated in Southeast Asia. Grows well in tropical and subtropical climates with good rainfall.",
    uses: "Essential in Thai, Indonesian, and Malaysian cooking. Used in Tom Yum and Tom Kha soups. Has digestive and anti-inflammatory properties. Used in traditional medicine across Asia.",
    indianNames: {
      Hindi: "Kulanjan",
      Bengali: "Kulanjan",
      Tamil: "Perarattai",
      Telugu: "Pedda Dumpa"
    },
    foreignNames: {
      Thai: "Kha",
      Indonesian: "Laos",
      Malay: "Lengkuas",
      Vietnamese: "Riềng"
    },
    category: "aromatic"
  },
  {
    id: "horseradish",
    name: "Horseradish",
    botanicalName: "Armoracia rusticana",
    family: "Brassicaceae",
    commercialPart: "Root",
    image: "horseradish",
    description: "Horseradish is a hardy perennial herb with large leaves, grown for its pungent root. The plant attains a height of 0.6-1.2 meters. The root contains oil with strong pungent odor and hot, biting taste when grated.",
    origin: "Native to Southeastern Europe and Western Asia. Cultivated in Europe, North America, and parts of Asia. Prefers cool climates and deep, moist, fertile soil.",
    uses: "Used as a condiment, especially with roast beef and in cocktail sauce. Prepared horseradish is mixed with vinegar. Has antibacterial properties and aids digestion. Used in Jewish Passover tradition.",
    indianNames: {
      Hindi: "Sahijan Ki Jar"
    },
    foreignNames: {
      French: "Raifort",
      German: "Meerrettich",
      Russian: "Khren",
      Polish: "Chrzan",
      Japanese: "Seiyō wasabi"
    },
    category: "root"
  },
  {
    id: "hyssop",
    name: "Hyssop",
    botanicalName: "Hyssopus officinalis",
    family: "Lamiaceae",
    commercialPart: "Leaves, Flowers",
    image: "hyssop",
    description: "Hyssop is an aromatic perennial herb, 30-60 cm high, grown at higher elevations above 1500 meters. The branches are erect or diffuse, leaves are sessile and linear-oblong. Flowers are bluish-purple in whorled spikes.",
    origin: "Native to Southern Europe and the Middle East. Grows in dry, rocky soils. Mentioned in the Bible for purification rituals.",
    uses: "Used to flavor liqueurs like Chartreuse and absinthe. Added to salads, soups, and meat dishes sparingly. Has expectorant and antiseptic properties. Used in perfumery and aromatherapy.",
    indianNames: {
      Hindi: "Jufa"
    },
    foreignNames: {
      French: "Hysope",
      German: "Ysop",
      Italian: "Issopo",
      Spanish: "Hisopo",
      Hebrew: "Ezov"
    },
    category: "herb"
  },
  {
    id: "juniper-berry",
    name: "Juniper Berry",
    botanicalName: "Juniperus communis",
    family: "Cupressaceae",
    commercialPart: "Berry (cone)",
    image: "juniper",
    description: "Juniper is an evergreen shrub sometimes attaining the height of a small tree up to 3 meters with erect trunk and spreading branches. The berries are actually small cones that take 2-3 years to ripen, turning from green to blue-black.",
    origin: "Native to the Northern Hemisphere across Europe, Asia, and North America. Grows in cool temperate and subarctic regions. Prefers dry, rocky hillsides.",
    uses: "Essential flavoring in gin. Used in European cuisines with game meats, sauerkraut, and pâtés. Has diuretic and digestive properties. Used in traditional medicine and aromatherapy.",
    indianNames: {
      Hindi: "Hauber",
      Bengali: "Hayubar"
    },
    foreignNames: {
      French: "Genièvre",
      German: "Wacholder",
      Italian: "Ginepro",
      Dutch: "Jeneverbes",
      Swedish: "En"
    },
    category: "aromatic"
  },
  {
    id: "lovage",
    name: "Lovage",
    botanicalName: "Levisticum officinale",
    family: "Apiaceae",
    commercialPart: "Leaves, Seeds, Root",
    image: "lovage",
    description: "Lovage is a hardy perennial growing up to 90 cm or more, producing yellow flowers in summer and dying down in autumn. It has a strong celery-like flavor but more intense. The entire plant is aromatic.",
    origin: "Native to Southern Europe and Western Asia. Widely cultivated in herb gardens. Prefers rich, moist soil in partial shade.",
    uses: "Used to flavor soups, stews, and salads. Seeds used in baking and pickling. Root used in herbal medicine as a diuretic. Young stems can be candied like angelica.",
    indianNames: {
      Hindi: "Kasturi Methi"
    },
    foreignNames: {
      French: "Livèche",
      German: "Liebstöckel",
      Italian: "Levistico",
      Dutch: "Lavas"
    },
    category: "herb"
  },
  {
    id: "marjoram",
    name: "Marjoram",
    botanicalName: "Origanum majorana",
    family: "Lamiaceae",
    commercialPart: "Leaves, Flowering tops",
    image: "marjoram",
    description: "Marjoram is a perennial aromatic herb. Its dried leaves and flower tops constitute the spice. Sweet marjoram is characterized by a strong, spicy, pleasant odor. The flavor is fragrant, slightly sharp, and bitterish.",
    origin: "Native to the Mediterranean region. Cultivated in Egypt, France, Germany, and the USA. Prefers warm, dry climates.",
    uses: "Used in Mediterranean and Middle Eastern cuisines. Flavors meats, vegetables, and sauces. Essential in herbs de Provence. Has antioxidant and antimicrobial properties.",
    indianNames: {
      Hindi: "Marwa",
      Bengali: "Murwa"
    },
    foreignNames: {
      French: "Marjolaine",
      German: "Majoran",
      Italian: "Maggiorana",
      Spanish: "Mejorana",
      Arabic: "Mardakush"
    },
    category: "herb"
  },
  {
    id: "mint",
    name: "Mint (Japanese Mint)",
    botanicalName: "Mentha arvensis",
    family: "Lamiaceae",
    commercialPart: "Leaves, Essential oil",
    image: "mint",
    description: "Japanese Mint is a perennial herb with creeping rootstalk and erect stems 1-2 feet tall, quadrangular and branched with short dense hair. Leaves are 2.5-5 cm long, oblong-ovate. The plant has a strong menthol aroma.",
    origin: "Native to temperate regions worldwide. India is a major producer of menthol oil, particularly in Uttar Pradesh. Grows in moist, fertile soil.",
    uses: "Leaves used fresh in cooking, beverages, and garnishes. Source of menthol oil used in pharmaceuticals, confectionery, and cosmetics. Aids digestion and freshens breath.",
    indianNames: {
      Hindi: "Pudina",
      Bengali: "Pudina",
      Gujarati: "Fudino",
      Tamil: "Pudina",
      Telugu: "Pudina"
    },
    foreignNames: {
      French: "Menthe",
      German: "Minze",
      Arabic: "Na'na",
      Japanese: "Hakka"
    },
    category: "herb"
  },
  {
    id: "oregano",
    name: "Oregano",
    botanicalName: "Origanum vulgare",
    family: "Lamiaceae",
    commercialPart: "Leaves",
    image: "oregano",
    description: "Oregano is a perennial herb with creeping roots, 30-90 cm high with branched woody stems and opposite, petiolate, hairy leaves about 1.5 cm long. The flowers are pale purple. It has a robust, earthy, slightly bitter taste.",
    origin: "Native to the Mediterranean region and Western Asia. Mexico is also a significant producer of Mexican oregano (different species). Thrives in warm, dry conditions.",
    uses: "Essential in Italian and Greek cuisines. Key ingredient in pizza and pasta sauces. Used dried more than fresh. Has strong antioxidant and antimicrobial properties.",
    indianNames: {
      Hindi: "Sathra"
    },
    foreignNames: {
      French: "Origan",
      German: "Oregano",
      Italian: "Origano",
      Spanish: "Orégano",
      Greek: "Rigani"
    },
    category: "herb"
  },
  {
    id: "parsley",
    name: "Parsley",
    botanicalName: "Petroselinum crispum",
    family: "Apiaceae",
    commercialPart: "Leaves",
    image: "parsley",
    description: "Parsley is the dried aromatic leaf of a biennial herb with dense foliage and white flowers. The bright green leaves are finely divided and curled (curly parsley) or flat (Italian parsley). It has a fresh, slightly peppery taste.",
    origin: "Native to the Mediterranean region. Widely cultivated worldwide. Two main types: curly-leaf and flat-leaf (Italian). Grows in temperate climates.",
    uses: "One of the most widely used culinary herbs. Used fresh as garnish and flavoring. Essential in bouquet garni and chimichurri. Rich in vitamins A, C, and K. Used medicinally as a diuretic.",
    indianNames: {
      Hindi: "Ajmood",
      Bengali: "Pichkil"
    },
    foreignNames: {
      French: "Persil",
      German: "Petersilie",
      Italian: "Prezzemolo",
      Spanish: "Perejil",
      Arabic: "Baqdounis"
    },
    category: "herb"
  },
  {
    id: "long-pepper",
    name: "Long Pepper",
    botanicalName: "Piper longum",
    family: "Piperaceae",
    commercialPart: "Dried fruit spike",
    image: "long-pepper",
    description: "Long pepper is the dried fruit of a slender, aromatic plant with creeping jointed stems and perennial woody roots. The leaves are 5-9 cm long, ovate, cordate. The fruit spike is 2.5-3.5 cm long, cylindrical, and has a more complex flavor than black pepper.",
    origin: "Native to India and was the predominant pepper in Europe before black pepper. Grows in tropical regions of India, Nepal, and Indonesia.",
    uses: "Used in Indian, Indonesian, and North African cuisines. Important in Ayurvedic medicine. Has a hotter, more complex flavor than black pepper with sweet undertones.",
    indianNames: {
      Hindi: "Pipali",
      Bengali: "Pipul",
      Gujarati: "Pipli",
      Tamil: "Thippili",
      Telugu: "Pippali"
    },
    foreignNames: {
      Arabic: "Dar Filfil",
      Indonesian: "Cabe Jawa"
    },
    category: "major"
  },
  {
    id: "pomegranate-seeds",
    name: "Pomegranate Seeds (Anardana)",
    botanicalName: "Punica granatum",
    family: "Lythraceae",
    commercialPart: "Dried seeds",
    image: "pomegranate",
    description: "Pomegranate is a deciduous shrub or small tree 5-8 meters high. The dried seeds (anardana) are obtained from wild, sour pomegranates. The seeds are dried with the pulp intact, giving them a dark, sticky appearance and tangy flavor.",
    origin: "Native to Iran and the Himalayas. Cultivated throughout the Mediterranean and South Asia. Wild pomegranates for anardana grow in the Himalayan foothills.",
    uses: "Used as a souring agent in North Indian cuisine, particularly in chutneys and curries. Sprinkled on chaat. Rich in antioxidants and vitamin C. Also used in Persian cuisine.",
    indianNames: {
      Hindi: "Anardana",
      Bengali: "Dalim",
      Gujarati: "Dadam",
      Punjabi: "Anardana",
      Urdu: "Anar"
    },
    foreignNames: {
      Persian: "Anar",
      Arabic: "Rumman",
      Turkish: "Nar"
    },
    category: "fruit"
  },
  {
    id: "rosemary",
    name: "Rosemary",
    botanicalName: "Rosmarinus officinalis",
    family: "Lamiaceae",
    commercialPart: "Leaves",
    image: "rosemary",
    description: "Rosemary is a dense, evergreen, hardy, perennial, aromatic herb growing up to 90 cm high with small pointed, sticky leaves 2-4 cm long. The leaves are dark green above and white below with a distinctive pine-like fragrance.",
    origin: "Native to the Mediterranean region. Grows on dry, rocky hillsides. Widely cultivated in herb gardens worldwide. Drought-tolerant once established.",
    uses: "Essential in Mediterranean cooking, especially with roasted meats and potatoes. Used in breads and focaccia. The essential oil is used in cosmetics and aromatherapy. Has memory-enhancing properties.",
    indianNames: {
      Hindi: "Rusmari"
    },
    foreignNames: {
      French: "Romarin",
      German: "Rosmarin",
      Italian: "Rosmarino",
      Spanish: "Romero",
      Greek: "Dendrolivano"
    },
    category: "herb"
  },
  {
    id: "sage",
    name: "Sage",
    botanicalName: "Salvia officinalis",
    family: "Lamiaceae",
    commercialPart: "Leaves",
    image: "sage",
    description: "Sage is a hardy sub-shrub with white, woolly stems 32-60 cm tall. Leaves are greyish-green, aromatic, petiolate, oblong, 7-8 cm long. On drying, leaves turn grey-green. The flavor is warm, aromatic, slightly bitter with camphor notes.",
    origin: "Native to the Mediterranean region. Cultivated worldwide. Grows best in well-drained soil in full sun. Drought-tolerant.",
    uses: "Used in stuffings, sausages, and fatty meats. Essential in Italian saltimbocca. Used to make sage tea. Has antiseptic and anti-inflammatory properties. Used in traditional medicine for sore throats.",
    indianNames: {
      Hindi: "Sefakuss",
      Kashmiri: "Sathi"
    },
    foreignNames: {
      French: "Sauge",
      German: "Salbei",
      Italian: "Salvia",
      Spanish: "Salvia",
      Arabic: "Maryamiya"
    },
    category: "herb"
  },
  {
    id: "sweet-flag",
    name: "Sweet Flag (Calamus)",
    botanicalName: "Acorus calamus",
    family: "Acoraceae",
    commercialPart: "Rhizome",
    image: "sweet-flag",
    description: "Sweet Flag is a perennial semi-aquatic marshy plant with creeping, much-branched aromatic rhizomes. The rhizome is cylindrical, about 19-25 mm in diameter and 10 cm long, light brown externally with a sweet, spicy aroma.",
    origin: "Native to Asia and Eastern Europe. Grows in wetlands and along water bodies. Found throughout India, particularly in marshy areas.",
    uses: "Used in Ayurvedic medicine for digestive disorders, nervous conditions, and respiratory problems. The essential oil is used in perfumery. Also used as a flavoring in some traditional beverages.",
    indianNames: {
      Hindi: "Vacha, Bach",
      Bengali: "Bach",
      Gujarati: "Ghodavaj",
      Tamil: "Vasambu",
      Telugu: "Vasa"
    },
    foreignNames: {
      French: "Acore Odorant",
      German: "Kalmus",
      Chinese: "Chang Pu"
    },
    category: "medicinal"
  },
  {
    id: "tarragon",
    name: "Tarragon",
    botanicalName: "Artemisia dracunculus",
    family: "Asteraceae",
    commercialPart: "Leaves",
    image: "tarragon",
    description: "Tarragon is a perennial herb growing to about 60 cm. The dried leaves and flowering tops are used for their flavor. French tarragon has a superior anise-like flavor, while Russian tarragon is hardier but less flavorful.",
    origin: "Native to Central Asia. French tarragon is the preferred culinary variety. Does not grow well in tropical climates.",
    uses: "Essential in French cuisine, particularly in béarnaise sauce and fines herbes. Used with chicken, fish, and eggs. The essential oil is used in perfumery. Has digestive properties.",
    indianNames: {
      Hindi: "Nagdona"
    },
    foreignNames: {
      French: "Estragon",
      German: "Estragon",
      Italian: "Dragoncello",
      Spanish: "Estragón",
      Russian: "Estragon"
    },
    category: "herb"
  },
  {
    id: "tejpat",
    name: "Tejpat (Indian Bay Leaf)",
    botanicalName: "Cinnamomum tamala",
    family: "Lauraceae",
    commercialPart: "Leaves",
    image: "tejpat",
    description: "Tejpat, also known as Indian Cassia, comes from a small to moderately sized evergreen tree. The leaves have a clove-like taste and faintly pepper-like odor, distinct from Mediterranean bay leaves. Three prominent veins run lengthwise.",
    origin: "Native to the Himalayan region of India and Nepal. Grows in subtropical to temperate forests at elevations of 900-2500 meters.",
    uses: "Essential in North Indian and Nepali cuisines, particularly in biryanis, kormas, and garam masala. Not interchangeable with Mediterranean bay leaves. Used in Ayurvedic medicine for digestive disorders.",
    indianNames: {
      Hindi: "Tej Patta",
      Bengali: "Tej Pata",
      Nepali: "Tej Pat",
      Gujarati: "Tamalpatra"
    },
    foreignNames: {
      English: "Indian Bay Leaf"
    },
    category: "leaf"
  },
  {
    id: "thyme",
    name: "Thyme",
    botanicalName: "Thymus vulgaris",
    family: "Lamiaceae",
    commercialPart: "Leaves",
    image: "thyme",
    description: "Thyme is a hardy perennial shrub 20-40 cm high. The dried leaves are curled, brownish-green, about 6-7 mm long. The flavor is aromatic, warm, and pungent. Flowers are small, pale purple to white.",
    origin: "Native to the Mediterranean region. Grows in dry, rocky soil in full sun. Widely cultivated as a culinary and ornamental herb.",
    uses: "Used in Mediterranean and Middle Eastern cuisines. Essential in bouquet garni and herbes de Provence. Pairs well with poultry, lamb, and tomatoes. Thymol has strong antiseptic properties.",
    indianNames: {
      Hindi: "Banajwain",
      Bengali: "Ban Ajwain"
    },
    foreignNames: {
      French: "Thym",
      German: "Thymian",
      Italian: "Timo",
      Spanish: "Tomillo",
      Arabic: "Zaatar"
    },
    category: "herb"
  }
];

// Get all unique categories
export const spiceCategories = [...new Set(spicesData.map(s => s.category))];

// Get spice by ID
export const getSpiceById = (id) => spicesData.find(s => s.id === id);

// Get spices by category
export const getSpicesByCategory = (category) => spicesData.filter(s => s.category === category);

// Category labels
export const categoryLabels = {
  major: "Major Spices",
  seed: "Seed Spices",
  premium: "Premium Spices",
  aromatic: "Aromatic Spices",
  leaf: "Leaf Spices",
  resin: "Resin & Gum",
  fruit: "Fruit Spices",
  bulb: "Bulb Spices",
  herb: "Herbs",
  bark: "Bark Spices",
  regional: "Regional Specialties",
  root: "Root Spices",
  medicinal: "Medicinal Spices"
};
